module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Sonnenflug")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ein Häher schwimmt aus der Fichte"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndunkel wogender Krone."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEr kreist im Abendlichte"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\neiner glühenden Zone.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Drauf bauscht er die Brust mit Wonne,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nbreitet lässig die Flügel,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nfährt dahin, wo die Sonne"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nschwindet hinter dem Hügel.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Mit gebietendem Fluge,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nglutengekrönter Stirne"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nfolgt er dem Flammenzuge,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwähnt sich im Reich der Gestirne.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page21",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" Hat der eigenen Schwere"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmajestätisch vergessen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndrängt in die Strahlenmeere"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nseine Schwingen vermessen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Tiefer sinken die Gluten,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nrauschend hebt sich der Häher."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nHoch in weltfernen Fluten"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nwiegt sich der einsame Späher.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Nur ein ersterbender Schimmer"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nliegt, wo die Sonne gesunken;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndoch noch immer, noch immer"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsteigt er, vom Lichte trunken.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Gierig saugen die Blicke,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsaugen ein glühend Verderben;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsinkt er ermattet zurücke,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nkann er nur sterben, nur sterben.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0